<template>
  <!-- 休暇申請 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休暇申請作成</h2>
      </CCardHeader>
      <CCardBody>
        <p class="preika-required-note">
        <span class="preika-required-note__mark" aria-hidden="true">*</span>
        <span>が付いている項目は必須入力項目です</span>
      </p>
          <ValidationObserver ref="obs" v-slot="ObserverProps">
            <CRow>
              <div class="container">
                <table class="table table-borderless">
                  <tr>
                    <th scope="row">プロジェクト<span class="asterisk">*</span></th>
                    <td>
                      <select
                        class="custom-select preika-form-control preika-form-control--wide"
                        v-model="project_id"
                        @change="syncProjectName"
                      >
                        <option v-for="p in projectList" :key="p.id" :value="p.id">
                          {{ p.name }}<template v-if="p.external">（現在所属外）</template>
                        </option>
                      </select>
                    </td>
                  </tr>
                <tr>
                  <th scope="row">種別<span class="asterisk">*</span></th>
                    <td>
                      <div class="preika-field-grid preika-field-grid--single">
                        <ValidationProvider name="種別" rules="select" v-slot="ProviderProps">
                          <div class="preika-field preika-field--without-label">
                            <select class="custom-select preika-form-control" v-model="type">
                              <option disabled value>選択してください</option>
                              <option v-for="option in type_options" :value="option.id" :key="option.id" >{{ option.name }}</option>
                            </select>
                            <p class="error preika-field__message">
                              <span class="error">{{ ProviderProps.errors[0] }}</span>
                            </p>
                          </div>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">日時</th>
                    <td>
                      <div class="preika-field-grid preika-field-grid--dates">
                        <div class="preika-field-column">
                          <ValidationProvider name="開始日" rules="required" v-slot="ProviderProps">
                            <div class="preika-field">
                              <label>開始日<span class="asterisk">*</span></label>
                              <CInput class="preika-form-control preika-form-control--native-icon" type="date" :min="date_min()" :max="date_max()" v-model="start_day" @change="autoTimeSet"/>
                              <p class="error preika-field__message">
                                <span class="error">{{ ProviderProps.errors[0] }}</span>
                              </p>
                            </div>
                          </ValidationProvider>
                          <ValidationProvider name="開始日の時間帯" v-slot="ProviderProps">
                            <div class="preika-field">
                              <label>開始日の時間帯</label>
                              <select class="custom-select preika-form-control" v-model="start_time">
                                <option disabled value>時間帯を選択してください</option>
                                <option v-for="option in selectableDays" :value="option.id" :key="option.id">{{ option.name }}</option>
                              </select>
                              <p class="error preika-field__message">
                                <span class="error">{{ ProviderProps.errors[0] }}</span>
                              </p>
                            </div>
                          </ValidationProvider>
                        </div>
                        <div class="preika-field-column">
                          <div class="preika-field">
                            <label>終了日</label>
                            <CInput class="preika-form-control preika-form-control--native-icon" type="date" :min="date_min()" :max="date_max()" v-model="end_day" @change="autoTimeSet"/>
                            <p class="preika-field__message" aria-hidden="true"></p>
                          </div>
                          <div class="preika-field">
                            <label>終了日の時間帯</label>
                            <select class="custom-select preika-form-control" v-model="end_time">
                              <option disabled value>時間帯を選択してください</option>
                              <option v-for="option in selectableDays" :value="option.id" :key="option.id">{{ option.name }}</option>
                            </select>
                            <p class="preika-field__message" aria-hidden="true"></p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">備考・事由など</th>
                    <td>
                      <CRow>
                        <CCol sm="6" lg="6">
                          <ValidationProvider name="備考" rules="max:100" v-slot="ProviderProps">
                            <textarea
                              class="form-control"
                              v-model="reason"
                              rows="2"
                              maxlength="100"
                            ></textarea>
                            <p class="error">
                              <span class="error">{{ ProviderProps.errors[0] }}</span>
                            </p>
                          </ValidationProvider>
                        </CCol>
                      </CRow>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">連絡先(電話番号等)</th>
                    <td>
                      <CRow>
                        <CCol sm="6" lg="6">
                          <ValidationProvider name="連絡先(電話番号等)" rules="max:100" v-slot="ProviderProps">
                            <textarea
                              class="form-control"
                              v-model="telephone"
                              rows="2"
                              maxlength="100"
                            ></textarea>
                            <p class="error">
                              <span class="error">{{ ProviderProps.errors[0] }}</span>
                            </p>
                          </ValidationProvider>
                        </CCol>
                      </CRow>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">事前承認済</th>
                    <td>
                      <div class="d-flex flex-column">

                        <!-- 弊社上長 -->
                        <div class="d-flex align-items-center mb-2">
                          <label class="custom-switch mb-0">
                            <input
                              type="checkbox"
                              class="custom-switch-input"
                              id="mgr-approved"
                              v-model="manager_approval"
                              @change="approved"
                            />
                            <span class="custom-switch-indicator" aria-hidden="true"></span>
                          </label>
                          <label for="mgr-approved" class="ml-2 mb-0">弊社上長</label>
                        </div>

                        <!-- 現場上長 -->
                        <div class="d-flex align-items-center">
                          <label class="custom-switch mb-0">
                            <input
                              type="checkbox"
                              class="custom-switch-input"
                              id="sup-approved"
                              v-model="supervisor_approval"
                              @change="approved"
                            />
                            <span class="custom-switch-indicator" aria-hidden="true"></span>
                          </label>
                          <label for="sup-approved" class="ml-2 mb-0">現場上長（お客様含む）</label>
                        </div>

                      </div>
                    </td>
                  </tr>
                </table>
                <CRow class="mt-3 align-items-center">
                  <CCol class="text-start">
                    <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                  </CCol>
                  <CCol class="text-center">
          <div class="d-flex justify-content-center flex-wrap" style="gap: 10px">
            <save-button
              :label="'保存'"
              :loading="loading"
              :btn-class="'btn btn-secondary'"
              action-kind="secondary"
              @click="apply(false)"
              :disabled="ObserverProps.invalid"
            />
            <save-button
              :label="'保存後、申請画面へ'"
              :loading="loading"
              @click="apply(true)"
              :disabled="ObserverProps.invalid"
            />
          </div>
        </CCol>
                  <CCol></CCol>
                </CRow>
              <label class="mt-2">※ 「保存後、申請画面へ」は保存だけを行い、既存の承認申請一覧へ移動します。申請先の選択・申請・通知は移動先で実行されます。</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import SaveButton from '../../common/SaveButton';

export default {
  components: { 
    SaveButton,
  },
  name: "PaidAndSubstitute",
  data() {
    return {
      date: "",
      name: "",
      items:"",
      type: "",
      type_options: [
        {
          id: ConstList.PAID_ID,
          name: ConstList.PAID_NAME
        },
        {
          id: ConstList.SUBSTITUTE_ID,
          name: ConstList.SUBSTITUTE_NAME
        },
        {
          id: ConstList.SPECIAL_ID,
          name: ConstList.SPECIAL
        },
        {
          /*
           * **欠勤は休暇ではないが、申請の種別としては持つ。**
           * 勤務表で欠勤を選べるのに申請が無いと、誰の承認も
           * 要らずに勤務表へ書けてしまう。
           */
          id: ConstList.ABSENCE_ID,
          name: ConstList.ABSENCE
        }
      ],
      start_day: "",
      start_time: [],
      end_day: "",
      end_time: [],
      allDays: [
        {
          id: ConstList.ALLDAY_ID,
          name: ConstList.ALLDAY
        },
        {
          id: ConstList.MORNING_ID,
          name: ConstList.MORNING
        },
        {
          id: ConstList.AFTERNOON_ID,
          name: ConstList.AFTERNOON
        }
      ],
      reason: "",
      telephone: "",
      approval_type: ConstList.NOT_SELECTED_ID,
      paidAndSudstituteList: "",
      manager_approval: false,
      supervisor_approval: false,
      projectList: [],
      project_id: null,
      project_name: "",
      /*
       * 半日単位の休暇を使う会社か。**既定は「使う」。**
       * 読めないうちに false にすると、開いた瞬間だけ選択肢が
       * 減って見える。
       */
      half_day_leave_flg: true,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  // DBから各種情報を取得
  mounted: function () {
    /*
     * 会社が半日単位の休暇を使うか。**失敗しても止めない。**
     * 読めなければ「使う」のままで、塞ぐのはサーバ側。
     */
    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/paidandsubstitute/leavePolicy')
      .then(res => {
        this.half_day_leave_flg = (res.data || {}).half_day_leave_flg !== false
      })
      .catch(() => {})
    {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/paidandsubstitute/settingProject')
        .then(res => {
          this.items = res.data;
          return axios.get(process.env.VUE_APP_API_ORIGIN + '/projects');
        })
        .then(({ data: belong }) => {
          const belongArr = (belong || []).map(p => ({ id: +p.id, name: p.name }));
          const belongIdSet = new Set(belongArr.map(p => p.id));

          // 休暇の保存履歴は新規画面では基本なし：items.project_name があれば履歴候補化
          const fromItems = this.items?.project_name
            ? [{ id: null, name: this.items.project_name }]
            : [];

          const map = new Map();
          [...belongArr, ...fromItems].forEach(p => {
            if (!map.has(p.id ?? -1)) {
              map.set(p.id ?? -1, {
                id: p.id,
                name: p.name,
                external: p.id != null ? !belongIdSet.has(p.id) : true
              });
            }
          });

          this.projectList = Array.from(map.values()).filter(x => x.id != null);

          if (!this.projectList.length) {
            alert("プロジェクト管理にて、プロジェクトを設定して下さい。");
            this.$router.push({ name: ConstList.ROUTE_PROJECT_LIST });
            return;
          }

          // 既定は一覧の先頭（経費と同じ思想：サーバ既定IDは使わない）
          this.project_id = this.projectList[0].id;
          this.project_name = this.projectList[0].name;
        })
          .catch(error => {
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
  computed: {
    /** 半日単位の休暇を使う会社か。読めないうちは「使う」。 */
    halfDayLeaveAllowed() {
      return this.half_day_leave_flg !== false;
    },
    SPECIAL_ID() {
      return ConstList.SPECIAL_ID;
    },
    /**
     * 時間帯の選択肢。
     *
     * **種別では絞らない。**前は特休のときだけ「終日」しか出して
     * いなかったが、勤怠区分へ 17 午前特休 / 18 午後特休 を足したので、
     * 有給・代休と同じように午前・午後を選べる。
     *
     * **会社の設定では絞る。**半日単位の休暇を使わない会社では
     * 「終日」だけにする。塞ぐ判定はサーバ側が持っていて、ここは
     * 見せないためだけ。
     *
     * 保存済みの半日は残す。フラグを切ったあとに過去の申請を開いて画面
     * だけ終日に見えると、DBの値と食い違って原因が分からなくなる。
     */
    selectableDays() {
      if (this.halfDayLeaveAllowed) {
        return this.allDays;
      }
      const keep = [String(this.start_time), String(this.end_time)];
      return this.allDays.filter(
        day => day.id === ConstList.ALLDAY_ID || keep.includes(String(day.id))
      );
    },
  },
  methods: {
    /*
     * **種別を変えても時間帯へ触らない。**
     *
     * 前は特休を選んだ瞬間に時間帯を終日へ戻していた。半日で申請させない
     * ための仕掛けで、いまは不要（勤怠区分に午前特休・午後特休がある）。
     * 戻す処理を残すと、午前を選んでから種別を特休へ変えた人の選択が
     * 黙って終日へ書き換わる。
     */
    apply: function(goToSubmission) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;
      if (this.start_time.length === 0) {
        this.start_time = '1';
      }
      if(this.end_day === ''){
        // 終了日が未入力なら一日のみの想定となるため空を代入
        this.end_time = '';
      }
      if( this.end_time.length === 0){
        this.end_day = '';
      }
      if (confirm) {
        this.loading = true;
        const params = new URLSearchParams();
        params.append("project_id", this.project_id);
        params.append("start_day", this.start_day);
        params.append("start_time", this.start_time);
        if(this.end_day !== ""){
          params.append("end_day", this.end_day);
          params.append("end_time", this.end_time);
        } else {
          params.append("end_day", this.start_day);
          params.append("end_time", this.start_time);
        } 
        params.append("type", this.type);
        params.append("reason", this.reason);
        params.append("telephone", this.telephone);
        params.append("approval_type", this.approval_type);
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/paidandsubstituteRegister",
            params
          )
          .then(response => {
            this.submit_flg = false;
            if (response.data === ConstList.SUCCESS) {
              this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
              alert(ConstList.REGISTER_MESSAGE);
              if (goToSubmission) {
                this.$router.push('/submission_approval/report_list');
              } else {
                this.$router.push({ name: '休暇申請' });
              }
            } else {
              alert(ConstList.APPLY_ERROR);
            }
          })
          .catch(error => {
            this.submit_flg = false;
            axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    autoTimeSet: function() {
      if (
        this.start_day !== "" &&
        this.end_day !== "" &&
        this.start_day !== this.end_day
      ) {
        // 配列でも数値でも同じ結果になるよう、直接入れる。
        // splice は配列にしか無く、選択済みだと数値が入っている。
        this.start_time = ConstList.ALLDAY_ID;
        this.end_time = ConstList.ALLDAY_ID;
      }
    },
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    approved: function() {
      if (this.manager_approval && this.supervisor_approval) {
        // 当上長および現場上長承認済の場合
        this.approval_type = ConstList.BOTH_APPROVAL_ID;
      }
      else if (this.manager_approval && !this.supervisor_approval) {
        // 当上長承認済を選択した場合
        this.approval_type = ConstList.MANAGER_APPROVAL_ID;
      }
      else if (!this.manager_approval && this.supervisor_approval) {
        // 現場上長承認済を選択した場合
        this.approval_type = ConstList.SUPERVISOR_APPROVAL_ID;
      }
      else {
        // 未選択の場合
        this.approval_type = ConstList.NOT_SELECTED_ID;
      }
    },
    valueCheck: function () {
      if ((this.type != '') || 
        (this.start_day != '') || 
        (this.start_time != '') || 
        (this.end_day != '') || 
        (this.end_time != '') || 
        (this.reason != '') || 
        (this.telephone != '') ||
        (this.manager_approval) ||
        (this.supervisor_approval)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST,
        })
      }
    },
  },
  onInputMaxLength(fieldName) {
    if (this[fieldName].length > 100) {
      this[fieldName] = this[fieldName].slice(0, 100);
    }
  },
  syncProjectName() {
    const p = this.projectList.find(x => x.id === this.project_id);
    this.project_name = p ? p.name : "";
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}

</style>
